import Cookies from "js-cookie";
export const LocalStorageExistence = (keyName, isStorageStringType = false) => {
    let domStorage = {
        isExist: false,
        data: undefined,
    };
    let storageData = localStorage.getItem(keyName);
    if (storageData === null ||
        storageData === "null" ||
        storageData === "undefined" ||
        storageData === undefined) {
        return domStorage;
    }
    else {
        domStorage = {
            isExist: true,
            data: !isStorageStringType ? JSON.parse(storageData) : storageData,
        };
        return domStorage;
    }
};
export const LocalStorageClear = (keyName, all) => {
    if (all) {
        localStorage.clear();
        return;
    }
    localStorage.removeItem(keyName);
    return;
};
export const SessionStorageExistence = (keyName, isStorageStringType = false) => {
    let domStorage = {
        isExist: false,
        data: undefined,
    };
    let storageData = sessionStorage.getItem(keyName);
    if (storageData === null ||
        storageData === "null" ||
        storageData === "undefined" ||
        storageData === undefined) {
        return domStorage;
    }
    else {
        domStorage = {
            isExist: true,
            data: !isStorageStringType ? JSON.parse(storageData) : storageData,
        };
        return domStorage;
    }
};
export const SessionStorageClear = (keyName, all) => {
    if (all) {
        sessionStorage.clear();
        return;
    }
    sessionStorage.removeItem(keyName);
    return;
};
export const CookiesExistence = (keyName, isStorageStringType = false) => {
    let domStorage = {
        isExist: false,
        data: undefined,
    };
    let storageData = Cookies.get(keyName);
    if (storageData === null ||
        storageData === "null" ||
        storageData === "undefined" ||
        storageData === undefined) {
        return domStorage;
    }
    else {
        domStorage = {
            isExist: true,
            data: !isStorageStringType ? JSON.parse(storageData) : storageData,
        };
        return domStorage;
    }
};
export const CookiesClear = (keyName, all) => {
    Cookies.remove(keyName);
    return;
};
export const DomainCookiesClear = (keyName) => {
    // const domain = window.location.hostname.includes("localhost")
    //     ? "localhost"
    //     : ".skilliq.co";
    // Cookies.remove(keyName, {
    //     domain: domain
    // });
    Cookies.remove(keyName);
    return;
};
